/* Editorial Crossfade: fundido de 620 ms para las cards y el modal de
   habitaciones. La foto saliente cubre la nueva hasta que está cargada; solo
   se anima opacidad, sin canvas ni deformación. Los clics rápidos conservan
   el destino. fijar(img, src) pone una foto directa y descarta lo pendiente. */
(function () {
  'use strict';
  var estados = new WeakMap(), activos = new Set();
  var reducido = matchMedia('(prefers-reduced-motion: reduce)');

  function cancelar(s) {
    s.ticket++;
    if (s.animacion) s.animacion.cancel();
    if (s.capa) s.capa.remove();
    s.animacion = s.capa = null; s.enCurso = false; s.pendiente = null;
    activos.delete(s);
  }
  function terminar(s, ticket) {
    if (ticket !== s.ticket) return;
    if (s.capa) s.capa.remove();
    s.capa = s.animacion = null; s.enCurso = false;
    activos.delete(s);
    var pendiente = s.pendiente; s.pendiente = null;
    if (pendiente) cambiar(s.img, pendiente);
  }
  function cambiar(img, src) {
    if (!img || !img.parentElement || !src) return;
    var s = estados.get(img);
    if (!s) {
      s = { img: img, ticket: 0, enCurso: false, pendiente: null };
      estados.set(img, s);
    }
    if (reducido.matches || !Element.prototype.animate) {
      cancelar(s); img.src = src; return;
    }
    if (s.enCurso) { s.pendiente = src; return; }
    if (src === img.getAttribute('src')) return;
    s.enCurso = true; s.destino = src; activos.add(s);
    var ticket = ++s.ticket, nueva = new Image();
    nueva.src = src;
    var carga = nueva.decode ? nueva.decode() : new Promise(function (ok, error) {
      if (nueva.complete) return nueva.naturalWidth ? ok() : error();
      nueva.onload = ok; nueva.onerror = error;
    });
    carga.then(function () {
      if (ticket !== s.ticket) return;
      if (!img.complete || !img.naturalWidth) {
        img.src = src; terminar(s, ticket); return;
      }
      var capa = document.createElement('div'), estilo = getComputedStyle(img);
      capa.className = 'foto-fundido-salida'; capa.setAttribute('aria-hidden', 'true');
      capa.style.backgroundImage = 'url(' + JSON.stringify(img.currentSrc || img.src) + ')';
      capa.style.backgroundPosition = estilo.objectPosition;
      // El fundido conserva también el paspartú de las fotos completas;
      // sin fondo opaco, la foto entrante asomaría de golpe por los laterales.
      capa.style.backgroundSize = estilo.objectFit === 'contain' ? 'contain' : 'cover';
      capa.style.backgroundColor = getComputedStyle(img.parentElement).backgroundColor;
      capa.style.transform = estilo.transform;
      capa.style.scale = estilo.scale;
      capa.style.transformOrigin = estilo.transformOrigin;
      img.after(capa); s.capa = capa;
      img.src = src;
      s.animacion = capa.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 620, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'forwards'
      });
      s.animacion.finished.then(function () { terminar(s, ticket); }, function () { terminar(s, ticket); });
    }, function () {
      if (ticket !== s.ticket) return;
      // El respaldo habitual de imágenes del sitio atiende una foto fallida.
      img.src = src; terminar(s, ticket);
    });
  }
  function fijar(img, src) {
    if (!img) return;
    var s = estados.get(img);
    if (s) cancelar(s);
    img.src = src;
  }
  reducido.addEventListener('change', function () {
    if (!reducido.matches) return;
    activos.forEach(function (s) {
      var destino = s.pendiente || s.destino;
      cancelar(s); s.img.src = destino;
    });
  });
  window.FotoFundido = { cambiar: cambiar, fijar: fijar };
})();
